import { RECURRENCE_MONTHS } from '@/function/expense/expense.tax.config';
import { anchorInMonth } from '@/function/recurring/recurring.period';
import type { TypeExpense } from '@/types/expense/types.expense';
import { isDayKey } from '@/utils/date/day.key';

const WALK_MAX = 1200;

const pad = (value: number): string => String(value).padStart(2, '0');

const after = (date: string, months: number, anchorDay: number): string => {
    const [year, month] = date.split('-').map(Number);
    const shifted = new Date(Date.UTC(year, month - 1 + months, 1));
    const targetYear = shifted.getUTCFullYear();
    const targetMonth = shifted.getUTCMonth() + 1;
    return `${targetYear}-${pad(targetMonth)}-${pad(anchorInMonth(targetYear, targetMonth, anchorDay))}`;
};

export function expenseRenewalPeriods(
    expense: Pick<TypeExpense, 'documentDate' | 'recurrence'> & Partial<Pick<TypeExpense, 'renewalAnchorDay' | 'renewalStopDate'>>,
    until: string,
): string[] {
    const months = RECURRENCE_MONTHS[expense.recurrence] ?? 0;
    if (!months || !isDayKey(expense.documentDate) || !isDayKey(until)) return [];

    const anchor = expense.renewalAnchorDay && expense.renewalAnchorDay > 0 ? expense.renewalAnchorDay : Number(expense.documentDate.slice(8, 10));
    const periods: string[] = [];
    let date = after(expense.documentDate, months, anchor);
    const stop = isDayKey(expense.renewalStopDate) ? expense.renewalStopDate : '';
    while (date <= until && (!stop || date < stop) && periods.length < WALK_MAX) {
        periods.push(date);
        date = after(date, months, anchor);
    }
    return periods;
}

export default expenseRenewalPeriods;
